import { observable, action } from 'mobx'
import Home, {
  IHomeGlobalInfo,
  IHomeInfo,
  IModule,
  IModuleInfo,
  IOperation,
} from '@themes/horizontal/services/api/Home'
import UserStore from './UserStore'
import Store from 'store'
import { RouteConfig } from 'react-router-config'
import { ModuleEnum } from '@src/routes/const'
import logoImage from '@images/homepage/home_icon_logo.png'

/** 交警网校主题增值服务枚举 */
export enum ModuleOperationEnum {
  OP_KNOWLEDGE_BASE_APP = 'KNOWLEDGE', // 文库对应的频道类型
  OP_LIVE_APP = 'LIVE', // 直播管理对应的频道类型
  OP_TOB_PAYMENT_APP = 'OP_TOB_PAYMENT_APP', // 支付管理
  OP_KNOWLEDGE_FIELD_APP = 'IKNOW', // 知圈
  OP_SHORT_VIDEO_APP = 'VIDEO', // 短视频
  OP_CLOUD_SCHOOL_TRAINING_ITEM_APP = 'CLOUD_SCHOOL_TRAIN', // 云校我的培训项目
}

export enum OperationEnum {
  KNOWLEDGE = 'OP_KNOWLEDGE_BASE_APP', // 文库对应的频道类型
  LIVE = 'OP_LIVE_APP', // 直播管理对应的频道类型
  OP_TOB_PAYMENT_APP = 'OP_TOB_PAYMENT_APP', // 支付管理
  IKNOW = 'OP_KNOWLEDGE_FIELD_APP', // 知圈
  VIDEO = 'OP_SHORT_VIDEO_APP', // 短视频
  CLOUD_SCHOOL_TRAIN = 'OP_CLOUD_SCHOOL_TRAIN_ITEM_APP',
}
export interface IHomeStore {
  style: any
  childrenStyle: any
  pushMessage: string
  /** PC全局配置信息 */
  homeGlobalInfo: IHomeInfo
  /** 频道列表 */
  moduleList: IModule[]
  /** 增值服务 */
  opertationList: string[]
  /** 钱包开关 */
  IS_OP_TOB_PAY: boolean
  getHomeInfo: (pageId: string) => void
  queryHomeChannelModule: (pageId: string) => Promise<IModule[]>
  queryVasOperation2NativeList: () => void
  setModuleList: (moduleList: IModule[]) => void
  filterRoute: (routes: RouteConfig[]) => RouteConfig[]
  /** 飘窗信息 */
  bayWindow: any
  frameTimer: any
  operationList: any
}

class HomeState implements IHomeStore {
  @observable public style = {}
  @observable public childrenStyle = {}
  @observable public pushMessage = 'N'
  @observable public homeGlobalInfo = {} as IHomeInfo
  @observable public moduleList = [] as IModule[]
  @observable public opertationList: string[]
  @observable public operationList = [] as string[] | any
  @observable public IS_OP_TOB_PAY = false
  @observable public bayWindow = {}
  @observable public frameTimer = null
  // 判断是否开启银行的直播申请的增值服务
  @observable public isShowLiveApply = false
  // 判断银E通增值服务开启
  @observable public YETIsVip = false

  @action
  public setModuleList = (moduleList: IModule[]) => {
    this.moduleList = moduleList
  }

  @action
  public getHomeInfo = async (pageId: string) => {
    if (UserStore.homeId) {
      const { code, body } = (await Home.queryHomeGlobalInfo(
        pageId
      )) as IHomeGlobalInfo
      if (+code === 0) {
        if (body.isOpenRollWindow) {
          this.getRollWindowInfo(UserStore.homeId)
        }
        this.homeGlobalInfo = body
        if (!body.logoUrl) {
          this.homeGlobalInfo.logoUrl = logoImage
        }
        // 针对旧项目钱包模块处理，后续版本重构后去掉
        Store.set('logoUrl', body.logoUrl || logoImage)
      } else {
        this.homeGlobalInfo.logoUrl = logoImage
        Store.set('logoUrl', '')
        // global.$message(message) 首页切换阻塞学习任务模块
      }
    }
  }
  @action
  private getRollWindowInfo = async (pageId: string) => {
    const res: any = await Home.getRollWindowInfo({ pageId })
    if (res.code * 1 === 0) {
      this.bayWindow = res.body || {}
    } else {
      global.$message(res.message)
    }
  }
  @action
  public filterRoute = (routes: RouteConfig[] = []) => {
    if (!routes.length) {
      return routes
    }

    const modules = this.moduleList.map(v => v.channelModuleType)  //开通的频道
    // 文库频道关闭，增值服务的文库可访问
    if(!modules.includes(ModuleOperationEnum.OP_KNOWLEDGE_BASE_APP) && this.operationList.includes(OperationEnum.KNOWLEDGE)) {
      modules.push(ModuleOperationEnum.OP_KNOWLEDGE_BASE_APP)
    }

    return routes.filter(v => {
      if (v.module) {
        if (v.module === ModuleEnum.HOME) {
          return true
        }
        return modules.includes(v.module)
      }
      return true
    })
  }

  @action
  public queryVasOperation2NativeList = async () => {
    const {
      code,
      body,
    } = (await Home.queryVasOperation2NativeList()) as IOperation
    if (code === 0) {
      const operationList = body.opertationList || []
      this.operationList = operationList.map(v => v.operationCode)
      this.IS_OP_TOB_PAY = this.operationList.includes(
        OperationEnum.OP_TOB_PAYMENT_APP
      )
      this.YETIsVip = this.operationList.includes('OP_SMART_PORTAL_SIGN_IN')
      this.isShowLiveApply = this.operationList.includes('OP_SMART_PORTAL_LIVE')
      // hooks需要mobx4.5以上
      Store.set('multipleView', this.YETIsVip)
    }
  }

  @action
  public queryHomeChannelModule = async (pageId: string) => {
    if (UserStore.homeId) {
      const { code, body } = (await Home.queryHomeChannelModule(
        pageId
      )) as IModuleInfo
      if (+code === 0) {
        const result = (await Home.queryVasOperation2NativeList()) as IOperation

        this.moduleList = body // 默认频道列表
        if (+code === 0) {
          const { opertationList = [] } = result.body || {}
          this.operationList = opertationList.map(v => v.operationCode) // 增值服务列表
          this.isShowLiveApply = this.operationList.includes('OP_SMART_PORTAL_LIVE')
          this.YETIsVip = this.operationList.includes('OP_SMART_PORTAL_SIGN_IN')
          Store.set('multipleView', this.YETIsVip)
          this.moduleList = body.filter(v => {
            // 根据增值服务过滤频道
            if (
              v.channelModuleType === ModuleOperationEnum.OP_KNOWLEDGE_BASE_APP
            ) {
              return this.operationList.includes(OperationEnum.KNOWLEDGE)
            }
            if (v.channelModuleType === ModuleOperationEnum.OP_LIVE_APP) {
              return this.operationList.includes(OperationEnum.LIVE)
            }
            // 知圈改成通用功能
            // if (
            //   v.channelModuleType === ModuleOperationEnum.OP_KNOWLEDGE_FIELD_APP
            // ) {
            //   return this.operationList.includes(OperationEnum.IKNOW)
            // }
            if (
              v.channelModuleType === ModuleOperationEnum.OP_SHORT_VIDEO_APP
            ) {
              return this.operationList.includes(OperationEnum.VIDEO)
            }
            return true
          })
          this.IS_OP_TOB_PAY = this.operationList.includes(
            OperationEnum.OP_TOB_PAYMENT_APP
          )
        }
        return this.moduleList
      } else {
        return [] as IModule[]
      }
    }
    return [] as IModule[]
  }

  @action
  public changeStyle = (style: object) => {
    this.style = style
  }
  public changeChildStyle = (style: object) => {
    this.childrenStyle = style
  }
  public changePushMessage = (pushMessage: string) => {
    this.pushMessage = pushMessage
  }
}
export default new HomeState()
